import { BordOneToneIcon } from 'components/NudosComponents';
import EditableOrderRow from '../EditableOrderRow/EditableOrderRow';
import EditableProductConfigOrderRow from '../EditableProductConfigOrderRow/EditableProductConfigOrderRow';
import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';
import { IOrderPriceEditionForm } from '../../OrderPriceEdition.types';
import './ToolOrderEdition.scss';

interface IToolOrderEditionProps {
  serial?: string;
  saleIndex: number;
}

const ToolOrderEdition = ({ serial, saleIndex }: IToolOrderEditionProps) => {
  const { control } = useFormContext<IOrderPriceEditionForm>();
  const { fields: sales } = useFieldArray({
    control,
    name: `sales`
  });
  const sale = useWatch({ control, name: `sales.${saleIndex}` });
  const orderProductPrices = sale?.orderProductPrices || [];

  return (
    <section className="toolOrderEdition">
      <div className="toolSerialContainer">
        <div className="toolSerial">
          <BordOneToneIcon variant="barCode2" customWidth="16px" stroke="black" standardSize={52} />
          <span>Serial:</span>
          <span>{serial}</span>
        </div>
      </div>
      <EditableOrderRow key={sales?.[saleIndex]?.id || `sale-${saleIndex}`} registerReference={`sales.${saleIndex}`} />
      {orderProductPrices?.map((productConfig, configIndex) => (
        <EditableProductConfigOrderRow
          key={`${sale?.id}-${productConfig?.configClassFeeId ?? productConfig?.id ?? configIndex}`}
          registerReference={`sales.${saleIndex}.orderProductPrices.${configIndex}`}
        />
      ))}
    </section>
  );
};

export default ToolOrderEdition;
